import PeriodicalPayments from './periodical-payments';
export default PeriodicalPayments;
